"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styles_1 = require("@mui/material/styles");
var Button_1 = __importDefault(require("shared/components/Button"));
var StyledButton = (0, styles_1.styled)(Button_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        borderRadius: '50%',
        padding: 0,
        margin: 0,
        minWidth: 0,
        color: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        lineHeight: '20px',
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            background: theme.palette.common.white,
            color: '#879DA9',
        },
        svg: {
            margin: 0,
            fontSize: 20,
            '&:hover': {
                color: '#879DA9',
            },
        },
    });
});
var SettingsIconButton = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, href = _a.href, _b = _a.size, size = _b === void 0 ? 'lg' : _b, rest = __rest(_a, ["icon", "onClick", "href", "size"]);
    return ((0, jsx_runtime_1.jsx)(StyledButton, __assign({ variant: "text", color: "inherit", onClick: onClick, href: href }, rest, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: size }) })));
};
exports.default = SettingsIconButton;
